import React from 'react';
import { AddButton } from '../buttons';
const buildAddNewRowRow = _ref => {
  let {
    isImmutableUnderReview,
    onAddRow,
    t
  } = _ref;
  return {
    key: 'add-row',
    className: 'row-add_row',
    showEdit: false,
    showDelete: false,
    opts: {
      sort: false,
      filterableByText: false
    },
    columns: [/*#__PURE__*/React.createElement(AddButton, {
      className: "position-fixed",
      variant: "link",
      isImmutableUnderReview: isImmutableUnderReview,
      onClick: onAddRow,
      text: t('add_row')
    }), /*#__PURE__*/React.createElement("div", {
      className: "p-3"
    })]
  };
};
export default buildAddNewRowRow;